import * as I18n from 'i18n-js';
import { regionalizePath, SUPPORTED_URL_REGIONS } from '@reverbdotcom/commons/src/url_helpers';
import { NavigateFunction } from 'react-router';
import { some } from 'lodash';

export enum ModalPage {
  Index = 'index',
  Create = 'create',
  Edit = 'edit',
}

interface CreditCardWalletModalState {
  headerTitle: string;
  saveButtonText: string;
  backButtonText: string;
  page: string;
  goBack: () => void;
  cancel: () => void;
}

export interface ModalPaths {
  start: string;
  index: string;
  create: string;
  edit: string;
}

export function buildModalState({ modalPaths, navigate, currentPathname }: {
  navigate: NavigateFunction, currentPathname: string, modalPaths: ModalPaths
}): CreditCardWalletModalState {
  const page = chooseModalPage(modalPaths, currentPathname);
  const headerTitle = translate(page, 'title');
  const saveButtonText = translate(page, 'saveButton');
  const backButtonText = translate(page, 'backButton');

  function cancel() {
    navigate(modalPaths.start);
  }

  function goBack() {
    if (page === ModalPage.Index) {
      cancel();
    } else {
      navigate(modalPaths.index);
    }
  }

  return {
    headerTitle,
    saveButtonText,
    backButtonText,
    goBack,
    cancel,
    page,
  };
}

function translate(page: ModalPage, key: 'title' | 'saveButton' | 'backButton') {
  return I18n.t(`discovery.creditCardWallet.modal.${page}.${key}`);
}

function chooseModalPage(paths: ModalPaths, currentPathname: string) {
  const isCreatePage = isModalPathActive(paths.create, currentPathname);
  const isEditPage = isModalPathActive(paths.edit, currentPathname);

  if (isEditPage) {
    return ModalPage.Edit;
  } else if (isCreatePage) {
    return ModalPage.Create;
  }

  return ModalPage.Index;
}

function stripQuery(path: string) {
  return path.split('?')[0];
}

function isModalPathActive(pathname: string, currentPathname: string) {
  return stripQuery(pathname) === currentPathname || isRegionalPathActive(pathname, currentPathname);
}

function isRegionalPathActive(pathname: string, currentPathname: string) {
  return some(SUPPORTED_URL_REGIONS, (region) => (
    regionalizePath(stripQuery(pathname), region) === currentPathname
  ));
}
